<div class="mainContent">
  <div>
    <button type="button" name="createUser" class="close-action" (click)="closeDialog()">
      Close
  </button>
  </div>
    <div class="heading">
      Site Terms
    </div>
    <div class="rectangle"></div>
    <div class='subHeading'>
      Last updated: February 22, 2021
    </div>
    <div class='content'>
      Welcome to the I Have Space website(the "Site"). Amazon Transportation Services Private Limited and/or its
      affiliates ("Amazon") operate the Site subject to the following terms of use (these "Site Terms"). By visiting the
      Site, you accept these Site Terms. Please read them carefully. If you do not agree to these Site Terms, please
      immediately discontinue using this Site. In addition, when you agree to provide any services to or on behalf of
      Amazon, you also will be subject to terms of service or other applicable agreements governing those services (the
      "Agreement").
    </div>
    <div class='policyHeading'>
      PRIVACY
    </div>
    <div class='content'>
      <a href="https://ihs-staging.mobinius.net/website/pages/policy.html" target="blank">Please review our Privacy Policy, which also governs your visit to the Site, to understand our practices.</a>
    </div>
    <div class='policyHeading'>
      ELECTRONIC COMMUNICATIONS
    </div>
    <div class='content'>
      When you visit the Site or provide your details, you are communicating with us electronically. Amazon will
      communicate with you via phone, text message, email, or by posting materials and notices to this website (each
      such communication, &quot;electronic communication&quot;). You consent to receive electronic communications from
      Amazon. Standard messaging and data rates may apply. You agree that all agreements, notices, disclosures and other
      electronic communications Amazon provides satisfy any legal
      requirement that such communications be in writing.
    </div>
    <div class='policyHeading'>
      COPYRIGHT</div>
    <div class='content'>
      All content included on the Site, such as text, interest forms, graphics, logos, button icons, images, audio
      clips, video clips, testimonials, blogs, digital downloads, data compilations, and software, is the property of
      Amazon or its content suppliers and protected by applicable laws. The compilation of all content on the Site is
      the exclusive property of Amazon and protected by applicable laws. All software used on the Site is the property
      of Amazon or its software suppliers and protected by applicable laws.
    </div>
    <div class='policyHeading'>
      TRADEMARKS
    </div>
    <div class='content'>
      <p><span><a href="https://www.amazon.com/gp/help/customer/display.html/?nodeId=200738910" target="_blank">Click here to see a non-exhaustive list of Amazon trademarks.</a></span> In addition, other Amazon
        graphics, logos, page headers, button icons, scripts, and service names are trademarks or trade dress of Amazon
        in the U.S. and other countries. Amazon&#39;s trademarks and trade dress may not be used in connection with any
        product or service that is not Amazon&#39;s, in any manner that is likely to cause confusion among customers, or
        in any manner that disparages or discredits Amazon. All other trademarks not owned by Amazon that appear on the
        Site are the property of their respective owners, who may or may not be affiliated with,
        connected to, or sponsored by Amazon. You may not use the Amazon trademarks, logo or other proprietary graphics
        or marks without Amazon&#39;s prior written consent and subject to such guidelines as Amazon may prescribe.
      </p>
    </div>
    <div class='policyHeading'>
      PATENTS
    </div>
    <div class='content'>
      <p>
        One or more patents owned by Amazon may apply to the Site and to the features and functionality
        accessible via the Site. Portions of the Site may operate under license of one or more patents.<a href="https://www.amazon.com/gp/help/customer/display.html/?nodeId=200204190" target="_blank"> Click here
          to see a non-exhaustive list of applicable Amazon patents and applicable licensed patents.</a>
      </p>
    </div>
    <div class='policyHeading'>
      LICENSE AND SITE ACCESS
    </div>
    <div class='content'>
      <p>
        Amazon grants you a limited license to access and make personal use of the Site and not to download
        (other than page caching), translate, reverse engineer, incorporate with your own works, transfer, adapt,
        modify or make derivative works based on it, or any portion of it, except with express written consent of
        Amazon. This license does not include any resale of the Site or its contents; any derivative use of the Site
        or its contents; any downloading or copying of Site and its contents; or any use of data mining, robots, or
        similar data gathering and extraction tools. Unless otherwise specified by Amazon in a separate license,
        your right to use any software, data, documentation or other materials that you access through the Site is
        subject to these Site Terms or, if applicable, the Agreement.
      </p>
      <p>
        The Site or any portion of the Site may not be reproduced, duplicated, copied, sold, resold, visited, or
        otherwise exploited for any purpose without the express written consent of Amazon. You may not frame or utilize
        framing techniques to enclose any trademark, logo, or other proprietary information (including images, text,
        page layout, or form) of Amazon without express written consent. You may not use any meta tags or any other
        "hidden text" utilizing Amazon’s name or trademarks without the express written consent of Amazon. Any
        unauthorized use immediately terminates the permission or license granted by Amazon. All rights not expressly
        granted to you in these Site Terms are reserved and retained by Amazon or other content providers. You may use
        the Site or any portion of the Site only as permitted by law. Amazon may update the Site at any time and without
        notice to you.
      </p>
    </div>
    <div class='policyHeading'>
      CONTENT
    </div>
    <div class='content'>
      <p>
        Visitors may not share any information or content which is incomplete, incorrect, illegal, obscene, threatening,
        defamatory, invasive of privacy, infringing of intellectual property rights, or otherwise injurious to third
        parties or objectionable and does not consist of or contain software viruses, political campaigning, commercial
        solicitation, chain letters, mass mailings, or any form of "spam." You may not use a false e-mail address,
        impersonate any person or entity, or otherwise mislead as to the origin of information or content. If you do
        submit information or material, and unless we indicate otherwise, you grant Amazon a nonexclusive, royalty-free,
        perpetual, irrevocable, and fully sublicensable right to use, reproduce, modify, adapt, publish, translate,
        create derivative works from, distribute, and display such information or content throughout the world in any
        media. You grant Amazon and sublicensees the right to use the name that you submit in connection with such
        content, if they choose. You acknowledge that Amazon may use such information or content in relation to the I
        Have Space Program or other Amazon products, services, programs and offerings and to send you electronic
        communications in relation to the foregoing.
      </p>
      <p>
        You represent and warrant that you own or otherwise control all of the rights to the information or content that
        you share; that the information or content is accurate; that use of the information or content you supply does
        not violate these Site Terms and will not cause injury to any person or entity; and that you will indemnify
        Amazon for all claims resulting from information or content you supply. Amazon takes no responsibility and
        assumes no liability for any information or content shared by you.
      </p>
    </div>
    <div class='policyHeading'>
      COPYRIGHT COMPLAINTS
    </div>
    <div class='content'>
      <p>
        Amazon respects the intellectual property of others. If you believe that your work has been copied in a way that
        constitutes copyright infringement, please follow our Notice and Procedure for Making Claims of Copyright
        Infringement below.
      </p>
    </div>
    <div class='policyHeading'>
      COPYRIGHT COMPLAINTS
    </div>
    <div class='content'>
      <p>
        Amazon respects the intellectual property of others. If you believe that your work has been copied in a way that
        constitutes copyright infringement, please follow our Notice and Procedure for Making Claims of Copyright
        Infringement below.
      </p>
    </div>
    <div class='policyHeading'>
      DISCLAIMER OF WARRANTIES / CONDITIONS AND LIMITATION OF LIABILITY
    </div>
    <div class='content'>
      <p class='disclaimer'>
        THE SITE AND ALL INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING ANY SOFTWARE) AND SERVICES INCLUDED ON OR
        OTHERWISE MADE AVAILABLE TO YOU THROUGH THE SITE ARE PROVIDED BY AMAZON ON AN "AS IS" AND "AS AVAILABLE" BASIS,
        UNLESS OTHERWISE SPECIFIED IN THE AGREEMENT. AMAZON MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS
        OR IMPLIED, AS TO THE OPERATION OF THE SITE OR THE INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING ANY
        SOFTWARE) OR SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE SITE, UNLESS OTHERWISE
        SPECIFIED IN THE AGREEMENT. YOU EXPRESSLY AGREE THAT YOUR USE OF THE SITE IS AT YOUR SOLE RISK. TO THE FULL
        EXTENT PERMISSIBLE BY APPLICABLE LAW, AMAZON DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT
        LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. AMAZON DOES NOT WARRANT
        THAT THE SITE; INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING ANY SOFTWARE) OR SERVICES INCLUDED ON OR
        OTHERWISE MADE AVAILABLE TO YOU THROUGH THE SITE; ITS SERVERS; OR E-MAIL SENT FROM AMAZON ARE FREE OF VIRUSES OR
        OTHER HARMFUL COMPONENTS. AMAZON WILL NOT BE LIABLE FOR ANY DAMAGES OF ANY KIND ARISING FROM THE USE OF THE SITE
        OR FROM ANY INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING SOFTWARE) OR SERVICES INCLUDED ON OR OTHERWISE
        MADE AVAILABLE TO YOU THROUGH THE SITE, INCLUDING BUT NOT LIMITED TO DIRECT, INDIRECT, INCIDENTAL, PUNITIVE, AND
        CONSEQUENTIAL DAMAGES, UNLESS OTHERWISE SPECIFIED IN THE AGREEMENT. CERTAIN LAWS DO NOT ALLOW LIMITATIONS ON
        IMPLIED WARRANTIES OR THE EXCLUSION OR LIMITATION OF CERTAIN DAMAGES. IF THESE LAWS APPLY TO YOU, SOME OR ALL OF
        THE ABOVE DISCLAIMERS, EXCLUSIONS, OR LIMITATIONS MAY NOT APPLY TO YOU, AND YOU MIGHT HAVE ADDITIONAL RIGHTS.
      </p>
      <p class='disclaimer'>
        AMAZON DOES NOT GUARANTEE THAT YOUR USAGE OF THE WEBSITE OR PROVISION OF ANY DETAILS TO AMAZON WILL RESULT IN A
        COMMERCIAL TRANSACTION OR ANY OTHER ARRANGEMENT WITH AMAZON. ALL DETAILS THAT YOU PROVIDE WILL BE EVALUATED BY
        AMAZON IN ITS SOLE DISCRETION AND IN SUCH MANNER AS AMAZON MAY CONSIDER FIT.
      </p>
    </div>
    <div class='policyHeading'>
      APPLICABLE LAW AND JURISDICTION
    </div>
    <div class='content'>
      <p>
        These Site Terms are governed by and construed in accordance with the laws of India. You agree, as we do, to
        submit to the exclusive jurisdiction of the courts at Delhi.
      </p>
    </div>
    <div class='policyHeading'>
      MODIFICATION AND SEVERABILITY
    </div>
    <div class='content'>
      <p>
        We reserve the right to make changes to these Site Terms (including any policies incorporated into these Site
        Terms) at any time and in our sole discretion, and any changes will be effective upon the earlier of (a)
        emailing the revised Site Terms or policies, or notice of such changes, to you at your email notice address, or
        (b) posting of the revised Site Terms or policies on the Site. If any provision of these Site Terms is deemed
        invalid, void, or unenforceable for any reason, that provision will be deemed severable and will not affect the
        validity or enforceability of any other provision of these Site Terms.
      </p>
    </div>
    <div class='policyHeading'>
      OUR ADDRESS
    </div>
    <div class='content'>
      <address>
        Amazon Transportation Services Private Ltd.<br>
        Block E, 14th Floor, Unit Nos. 1401 to 1421 <br>
        International Trade Tower, Nehru Place <br>
        New Delhi – 110 019
      </address>
    </div>
    <div class='policyHeading'>
      NOTICE AND PROCEDURE FOR MAKING CLAIMS OF COPYRIGHT INFRINGEMENT
    </div>
    <div class='content'>
      <p>
        If you believe that your work has been copied in a way that constitutes copyright infringement, please provide
        our copyright agent the written information specified below:
      </p>
    </div>
    <div class='content' style="margin-top: 0px;padding-top: 0px;">
      <ul>
        <li>An electronic or physical signature of the person authorized to act on behalf of the owner of the copyright
          interest;</li>
        <li>A description of the copyrighted work that you claim has been infringed upon;</li>
        <li>A description of where the material that you claim is infringing is located on the Site;</li>
        <li>Your address, telephone number, and e-mail address;</li>
        <li>A statement by you that you have a good-faith belief that the disputed use is not authorized by the
          copyright owner, its agent, or the law; and</li>
        <li>A statement by you, made under penalty of perjury, that the above information in your notice is accurate and
          that you are the copyright owner or authorized to act on the copyright owner’s behalf.</li>
      </ul>
    </div>
    <div class='content'>
      <p>
        Amazon’s Copyright Agent for notice of claims of copyright infringement can be reached as follows:
      </p>
      <address>
        Copyright Agent <br>
        Amazon.com Legal Department<br>
        P.O. Box 81226<br>
        Seattle, WA 98108-1226<br>
        Phone: (206) 266-4064<br>
        Fax: (206) 266-7010<br>
        E-mail:<a href = "mailto:copyright@amazon.com">copyright@amazon.com</a>
        <!-- E-mail: copyright@amazon.com -->

      </address>
    </div>
    <div class='content'>
      <address>
        <span style="font-style: normal;"> address:</span><br>
        Copyright Agent<br>
        Amazon.com Legal Department<br>
        2021 7th Avenue<br>
        Seattle, WA 98121<br>
        USA
      </address>
    </div>
    <div class='content' style="padding-top: 0px;">
      Please note that this procedure is exclusively for notifying Amazon that your copyrighted material has been
      infringed
    </div>
  </div>